// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tq_a bik_b bik_bj","SubscribedPhotoblogs__link":"tq_b bik_a bik_r"};